const ELIGIBLE_STATUSES = new Set(["Accepted", "Paid", "Completed"]);
const ELIGIBLE_BOOKING_TYPES = new Set(["Hot bed", "Cold bed"]);

export function canManageReservationAmendment(booking) {
  return Boolean(
    booking &&
      ELIGIBLE_STATUSES.has(booking.status) &&
      booking.checkOutDate &&
      ELIGIBLE_BOOKING_TYPES.has(booking.bookingType),
  );
}
